import { Component, OnInit, OnDestroy } from '@angular/core';
import { FactorTableComponent } from '../../../../_shared/components/factor-table/factor-table.component';
import { FuelKpiRequest } from '../../../../_shared/models';
import { KpiFactorResponse } from '../../../../_shared/models/fuel-kpi-factor-response.model';
import { FuelChangesService } from '../../../services/fuel-changes.service';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-total-fuel-loss-modal',
  standalone: true,
  imports: [FactorTableComponent],
  templateUrl: './total-fuel-loss-modal.component.html',
  styleUrl: './total-fuel-loss-modal.component.scss',
})
export class TotalFuelLossModal implements OnInit, OnDestroy {
  request: FuelKpiRequest;
  modalFilterHeaders: any;
  factorsData: KpiFactorResponse[] = [];
  formatters = {
    'Total Loss Volume': (value: number): string => `${value.toFixed(0)}ℓ`,
    'Avg Loss Per Event': (value: number): string => `${value.toFixed(0)}ℓ`,
    'Percentage of Affected Assets': (value: number): string => `${value.toFixed(2)}%`,
    'Location Breakdown': (value: string): string => value ?? 'N/A',
  };

  private cancelSubject: Subject<void> = new Subject<void>();

  constructor(private fuelChangesService: FuelChangesService, private errorHandler: ErrorHandlerService) { }

  ngOnInit(): void {
    if (this.request) {
      this.getFuelLossKpiFactors();
    }
  }

  async getFuelLossKpiFactors(): Promise<void> {
    try {
      const response = await this.fuelChangesService.getFuelLossKpiFactors(
        this.request,
        this.cancelSubject
      );

      this.factorsData = response.data ?? [];
    } catch (error: any) {
      this.errorHandler.handleError(error);
    }
  }

  ngOnDestroy(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
  }
}
